export const malaysiaPrimaryColor = "#cc5500" // contrast of 3 with white
export const malaysiaPrimaryColorWithOpacity = (opacity: number) => `rgba(204,85,0,${opacity})`
export const malaysiaPrimaryColorDarker = "#ad4800" // 15% darker
